module.exports = __webpack_public_path__ + "static/img/center.b0b48ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center.png
// module id = 219
// module chunks = 1